export default __webpack_public_path__ + "static/media/gyroY.ee0d2fae.svg";